<template>
  <input :value="value" ref="input" :state="state" readonly/>
</template>

<script>
import baseInput from './_base'

export default {
  mixins: [baseInput],
}
</script>

<style lang="scss">
.live-input--readonly {
  padding-top: 1rem;
  font-size: $font-size-sm;

  &.live-input .form-label {
    left: 0;
  }

  input {
    display: block;
    width: 100%;
    border: 0;
  }
}
</style>